import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ArrowClockwise } from "@phosphor-icons/react";

export function CaptchaField({ value, onChange, onId, refreshKey }) {
  const [image, setImage] = useState("");
  const [error, setError] = useState("");
  const load = useCallback(() => {
    setError(""); onChange("");
    api.get("/auth/captcha")
      .then(({ data }) => { setImage(data.image); onId(data.captcha_id); })
      .catch(() => setError("Could not load the security picture. Try again."));
  }, [onChange, onId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  return (
    <div className="space-y-2" data-testid="captcha-field">
      <Label htmlFor="captcha-answer">Security check</Label>
      <div className="flex items-center gap-3">
        {image ? <img src={image} alt="Security characters" className="h-[60px] rounded border border-border" data-testid="captcha-image" />
          : <div className="h-[60px] w-[175px] rounded border border-border bg-muted" />}
        <Button type="button" variant="outline" size="icon" onClick={load} aria-label="New picture" data-testid="captcha-refresh"><ArrowClockwise size={17} /></Button>
      </div>
      <Input id="captcha-answer" data-testid="captcha-answer" required maxLength={12} autoComplete="off" value={value}
        onChange={(e) => onChange(e.target.value)} placeholder="Type the 5 characters you see" />
      {error && <p className="text-xs text-destructive" data-testid="captcha-error">{error}</p>}
    </div>
  );
}
